export const HUT_TRACKER_URL = process.env.HUT_TRACKER_URL ?? '';
export const HUT_SITE_ID = process.env.HUT_SITE_ID ?? '';
export const HUT_MATOMO_SRC = process.env.HUT_MATOMO_SRC ?? '';
